import React from "react";

import { USER_ACTIONS } from "Bands/types";
import { DeleteUserEntityModal } from "Bands/containers";
import { copy } from "shared/assets";
import { useDispatch } from "react-redux";
import { deleteUserEmergencyContact } from "Bands/state";

const { userEmergencyContact: contactCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const DeleteUserEmergencyContactModal: React.FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(deleteUserEmergencyContact(id));
  };

  return (
    <DeleteUserEntityModal
      type="emergency contact"
      action={USER_ACTIONS.deleteUserEmergencyContact}
      successMessage={contactCopy.messages.deleted}
      handleDelete={handleDelete}
      handleClose={handleClose}
    />
  );
};
